import { render, staticRenderFns } from "./Microscapes.vue?vue&type=template&id=479a60bd&lang=pug&"
import script from "./Microscapes.vue?vue&type=script&lang=ts&"
export * from "./Microscapes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports